import { useSummaryV2 } from '@/hooks/useCompany';

const COMPANY_UNIQUE_SYMBOL_FOR_KEYWORD_EXPERIMENT = [
  'NasdaqGS:MSFT', // USA
  'NasdaqGS:NVDA', // USA
  'ASX:FMG', // AU
  'ASX:CBA', // AU
  'LSE:SHEL', // UK
  'LSE:ULVR', // UK
];

export const useCompanyKeywordExperiment = () => {
  const summary = useSummaryV2();

  // Avoid running in test environment
  if (NODE_ENV === 'test') {
    return { hasKeywordExperiment: false };
  }

  if (!summary.uniqueSymbol) {
    return { hasKeywordExperiment: false };
  }

  const hasKeywordExperiment =
    COMPANY_UNIQUE_SYMBOL_FOR_KEYWORD_EXPERIMENT.includes(summary.uniqueSymbol);

  return { hasKeywordExperiment };
};
